import { createFileRoute, redirect } from '@tanstack/react-router'
import { useState } from 'react'
import { Sentry } from '@/lib/sentry'
import { apiClient } from '@/lib/api-client'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export const Route = createFileRoute('/_authenticated/sentry-test')({
  beforeLoad: () => {
    if (import.meta.env.PROD) {
      throw redirect({ to: '/' })
    }
  },
  component: SentryTestPage,
})

function SentryTestPage() {
  const [crash, setCrash] = useState(false)

  if (crash) {
    // This intentionally crashes render to validate ErrorBoundary + Sentry event.
    throw new Error('Sentry test: React render crash')
  }

  return (
    <div className='mx-auto flex w-full max-w-2xl flex-col gap-4 p-6'>
      <Card>
        <CardHeader>
          <CardTitle>Sentry test page (dev only)</CardTitle>
        </CardHeader>
        <CardContent className='flex flex-col gap-3'>
          <div className='flex flex-wrap gap-3'>
            <Button variant='destructive' onClick={() => setCrash(true)}>
              Crash React render
            </Button>
            <Button
              variant='outline'
              onClick={() => Sentry.captureException(new Error('Sentry test: captured exception'))}
            >
              Capture exception (handled)
            </Button>
            <Button
              variant='outline'
              onClick={() => {
                // Unhandled promise rejection (should be captured by Sentry).
                void Promise.reject(new Error('Sentry test: unhandled promise rejection'))
              }}
            >
              Unhandled promise rejection
            </Button>
          </div>

          <div className='flex flex-wrap gap-3'>
            <Button
              variant='secondary'
              onClick={async () => {
                // This will be captured by the Axios interceptor (404/5xx/network).
                await apiClient.get('/__sentry_test__does_not_exist')
              }}
            >
              Trigger API error (404)
            </Button>
            <Button
              variant='ghost'
              onClick={() => {
                Sentry.showReportDialog()
              }}
            >
              Open Sentry feedback dialog
            </Button>
          </div>

          <p className='text-sm text-muted-foreground'>
            Open this page at <span className='font-mono'>/sentry-test</span> (requires login). In
            production this route redirects to home.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
